import { render } from "./AsahiRadioButton.vue?vue&type=template&id=4d4fea44&scoped=true"
import script from "./AsahiRadioButton.vue?vue&type=script&lang=js"
export * from "./AsahiRadioButton.vue?vue&type=script&lang=js"

import "./AsahiRadioButton.vue?vue&type=style&index=0&id=4d4fea44&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4fea44"]])

export default __exports__